export const baseData = {
  title: "PRODUCT MATERIAL"
}